export const uk = {
    'empty-header': 'Минус-фразы не выбраны',
    'empty-text': 'Здесь будет список минус-фраз, которые можно добавить к группе объявлений',
    'remove-action': 'Очистить список',
    title: 'Минус-фразы'
};
